import React from "react";
import ReactDOM from "react-dom";
import { Router } from "react-router-dom";
import { CookiesProvider } from "react-cookie";
import * as serviceWorker from "./serviceWorker";
import * as Sentry from '@sentry/browser';

import history from "./utils/history";
import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary";

import "semantic-ui-less/semantic.less";
import "react-table/react-table.css";
import "flatpickr/dist/themes/light.css";
import 'react-dropzone-uploader/dist/styles.css'
import "./index.css";

if (process.env.REACT_APP_SENTRY_DSN) {
  try {
    Sentry.init({dsn: process.env.REACT_APP_SENTRY_DSN});
  } catch (e) {
    
  }
}

ReactDOM.render(
  <CookiesProvider>
    <Router history={history}>
      <ErrorBoundary history={history}>
        <App />
      </ErrorBoundary>
    </Router>
  </CookiesProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
